import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 .72a7 7 0 100 14 7 7 0 000-14zm0 12.6a5.6 5.6 0 110-11.2 5.6 5.6 0 010 11.2zm.3-8.6a.7.7 0 00-.7.7v2.8H5.2a.7.7 0 100 1.4h2.1a.7.7 0 00.7-.7v-3.5a.7.7 0 00-.7-.7z"
});

function SvgClockNine(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref);
}

export default SvgClockNine;